var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AddFormItem',{attrs:{"bp":_vm.bp,"fields":_vm.fields,"custom_icon":_vm.custom_icon},on:{"submit":_vm.submit_action}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }